// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__nAWM1","cell":"ColumnAccessor_cell__8sjdA","firstCellAccent":"ColumnAccessor_firstCellAccent__19aLG"};